import { render, staticRenderFns } from "./DownpaymentActivity.vue?vue&type=template&id=207d6756&scoped=true&"
import script from "./DownpaymentActivity.vue?vue&type=script&lang=js&"
export * from "./DownpaymentActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=207d6756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d6756",
  null
  
)

export default component.exports